import { replaceAllComplex, umcodeURL } from './mol_function';
import { pushError } from './pushError';

function browserUrlToReactUrlIntern(pathname, search) {
  if ((search == null || search == '') && pathname.indexOf('?') > 0) {
    let split = pathname.indexOf('?');
    search = pathname.substr(split);
    pathname = pathname.substr(0, split);
  }

  if (search != null && search.length > 1 && search[0] == '?')
    search = search.substr(1);

  if (pathname.startsWith('https://www.moluna.de')) {
    pathname = pathname.substr('https://www.moluna.de'.length);
  }

  if (pathname.length > 1 && pathname[0] == '/') pathname = pathname.substr(1);

  if (pathname == 'search_page/') {
    let parts = search.split('&');

    let otherParts = [];
    let fqZZZParts = [];

    let keyword = '*';

    for (let i = 0; i < parts.length; i++) {
      if (parts[i].startsWith('fqZZZ')) {
        if (parts[i].includes('%')) {
          //let tmp = replaceAllComplex(parts[i], [{ s: '%2C', r: ',' }]);
          //fqZZZParts.push(tmp);
          let kv = parts[i].split('=');
          let value = decodeURI(kv[1]);
          value = replaceAllComplex(value, [
            { s: '%2F', r: '___' },
            { s: '%2C', r: ',' },
          ]);
          fqZZZParts.push(kv[0] + '=' + value);
        } else fqZZZParts.push(parts[i]);
      } else if (parts[i].startsWith('keyword')) {
        keyword = replaceAllComplex(decodeURI(parts[i].split('=')[1]), [
          { s: '%2C', r: ',' },
        ]);
      } else if (parts[i] != '') {
        otherParts.push(parts[i]);
      }
    }

    fqZZZParts.sort();
    otherParts.sort();

    let paramsArray = fqZZZParts;

    if (keyword != '*') {
      paramsArray.push('keyword=' + keyword);
    }

    paramsArray = paramsArray.concat(otherParts);

    let url = '/search_page/?';

    url = url + paramsArray.join('&');

    return url;
  } else if (pathname.endsWith('/s/') || pathname.endsWith('/k/')) {
    let path = pathname;
    if (path[0] == '/') path = path.substring(1);
    path = path.substring(0, path.length - 3);
    let parts = path.split('/');
    if (pathname.endsWith('/s/')) {
      let baseUrl = '/search_page/?';
      for (let i = 0; i < parts.length; i += 2) {
        let key = parts[i];
        let value = replaceAllComplex(parts[i + 1], [{ s: '___', r: '%2F' }]);
        baseUrl += 'fqZZZ' + key + '=' + value;
        if (i + 2 < parts.length) baseUrl += '&';
      }

      if (search != null && search.length > 0) baseUrl += '&' + search;
      return baseUrl;
    } else {
      let baseUrl = '/search_page/?keyword=' + parts[0];
      if (search != '') {
        baseUrl = baseUrl + '&' + search;
      }
      return baseUrl;
    }
  } else if (
    pathname == 'index.php' &&
    search.indexOf('main_page=advanced_search_result') != -1
  ) {
    let parts = search.split('&');

    let otherParts = [];
    let fqZZZParts = [];

    let keyword = '*';

    for (let i = 0; i < parts.length; i++) {
      let kvp = parts[i].split('=');
      if (kvp[0].startsWith('fqZZZ')) {
        let value2 = replaceAllComplex(kvp[1], [{ s: '%26', r: '_-_' }]);
        fqZZZParts.push(kvp[0] + '=' + value2);
      } else if (kvp[0] == 'keyword') {
        let tmp = kvp[1];
        tmp = replaceAllComplex(tmp, [
          { s: '%2C', r: ',' },
          { s: '%2F', r: '___' },
        ]);
        tmp = decodeURI(tmp);
        keyword = tmp;
      } else if (parts[i] == 'main_page=advanced_search_result') {
        //skip
      } else {
        otherParts.push(parts[i]);
      }
    }

    fqZZZParts.sort();
    otherParts.sort();

    let paramsArray = fqZZZParts;

    if (keyword != '*') {
      paramsArray.push('keyword=' + encodeURI(keyword));
    }

    paramsArray = paramsArray.concat(otherParts);

    let url = '/search_page/?';

    url = url + paramsArray.join('&');

    return url;
  } else if (pathname.startsWith('product_info/')) {
    if (search == '') return '/' + pathname;
    else return '/' + pathname + '?' + search;
  } else if (pathname == 'shopping_cart/') {
    return '/shopping_cart/';
  } else if (pathname == 'container/') {
    return '/container/';
  } else if (pathname == 'check') {
    return '/check';
  } else if (
    pathname.toLowerCase().startsWith('buch/') ||
    pathname.toLowerCase().startsWith('musik/') ||
    pathname.toLowerCase().startsWith('film/') ||
    pathname.toLowerCase().startsWith('spielware/') ||
    pathname.toLowerCase().startsWith('games/') ||
    pathname.toLowerCase().startsWith('software/') ||
    pathname.toLowerCase().startsWith('kalender/') ||
    pathname.toLowerCase().startsWith('lifestyle/') ||
    pathname.toLowerCase().startsWith('schreibwaren/') ||
    pathname.toLowerCase().startsWith('noten/')
  ) {
    let indexKat = pathname.indexOf('/');
    let link1 = pathname.substr(indexKat + 1);
    let indexMinus = link1.indexOf('-');
    let productId = link1.substr(0, indexMinus);
    return '/product_info/' + productId;
  } else if (pathname == '/') {
    return '/';
  }

  return '';
}

export function browserUrlToReactUrl(pathname, search) {
  let response = browserUrlToReactUrlIntern(pathname, search);
  return response;
}

export function reactUrlToApiUrl(pathname) {
  if (pathname.startsWith('/search_page/')) {
    let params = pathname.substring(14);
    //let params = replaceAllComplex(pathname.substring(14), [
    //{ s: '%2F', r: '/' },
    //]);

    params = encodeURI(params);
    params = replaceAllComplex(params, [
      { s: ',', r: '%2C' },
      { s: '___', r: '%2F' },
      { s: '%253F', r: '%3F' },
      { s: '%253A', r: ':' },
      { s: '%2526', r: '%26' },
    ]);

    if (!params.includes('keyword=')) {
      if (params.length == 0) params = 'keyword=';
      else params += '&keyword=';
    }

    return '/index.php?frame=api&main_page=advanced_search_result&' + params;
  } else if (pathname.startsWith('/product_info/')) {
    let productID = pathname.substring(14);
    return (
      '/index.php?frame=api&main_page=product_info&products_id=' + productID
    );
  } else if (pathname == '/shopping_cart/') {
    return '/index.php?frame=api&main_page=shopping_cart';
  } else if (pathname == '/') {
    return '/index.php?frame=api&main_page=start';
  } else if (pathname == '/container/') {
    return '/container/';
  } else if (pathname == '/check') {
    return '/index.php?frame=api&main_page=check';
  } else throw new Error('Method path not implemented yet.');
}

function reactUrlToBrowserUrlIntern(
  pathname: string,
  search: string | null,
  apidata: any,
) {
  if (search == null && pathname.indexOf('?') > 0) {
    search = pathname.substr(pathname.indexOf('?'));
    pathname = pathname.substr(0, pathname.indexOf('?'));
  }

  if (pathname == '/search_page/' && search != null) {
    search = search.substr(1);
    let otherParts = [];
    let fqZZZParts = [];
    let parts = search.split('&');

    let keyword = '*';

    for (let i = 0; i < parts.length; i++) {
      if (parts[i].startsWith('fqZZZ')) {
        fqZZZParts.push(replaceAllComplex(parts[i], [{ s: '%2F', r: '___' }]));
      } else if (parts[i].startsWith('keyword')) {
        keyword = decodeURI(parts[i].split('=')[1]);
      } else {
        otherParts.push(parts[i]);
      }
    }

    fqZZZParts.sort();

    otherParts.sort();

    let url = '/';

    for (let i = 0; i < fqZZZParts.length; i++) {
      let kv = fqZZZParts[i].split('=');
      url = url + kv[0].substr(5) + '/' + kv[1] + '/';
    }

    if (fqZZZParts.length > 0) {
      url = url + 's/';
      if (keyword != '*') {
        url =
          url +
          '?keyword=' +
          replaceAllComplex(keyword, [{ s: ',', r: '%2C' }]);
        if (otherParts.length > 0) url = url + '&';
      } else if (otherParts.length > 0) {
        url = url + '?';
      }
    } else if (keyword != '*' && keyword != '') {
      url = '/' + keyword + '/k/';
      if (otherParts.length > 0) url = url + '?';
    } else {
      url = '/index.php?main_page=advanced_search_result';
      if (otherParts.length > 0) url = url + '&';
    }
    url = url + otherParts.join('&');
    return url;
  } else if (pathname.startsWith('/product_info/') && apidata != null) {
    return apidata.body.linkShort;
  } else if (pathname.startsWith('/product_info/') && apidata == null) {
    return '';
  } else if (pathname == '/shopping_cart/') {
    return '/index.php?main_page=shopping_cart';
  } else if (pathname == '/') {
    return '/';
  } else if (pathname == '') {
    return '';
  } else if (pathname == '/container/' && apidata != null) {
    return apidata.body.urlPath;
  } else if (pathname == '/container/' && apidata == null) {
    return '';
  } else {
    debugger;
  }
}

export function reactUrlToBrowserUrl(
  pathname: string,
  search: string,
  apidata: any,
) {
  let response = reactUrlToBrowserUrlIntern(pathname, search, apidata);
  return response;
}

export function sortSearchParams(input: string) {
  let otherParts = [];
  let fqZZZParts = [];
  let parts = input.split('&');

  let keyword = '*';

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].startsWith('fqZZZ')) {
      fqZZZParts.push(replaceAllComplex(parts[i], [{ s: '%2F', r: '___' }]));
    } else if (parts[i].startsWith('keyword')) {
      keyword = decodeURI(parts[i].split('=')[1]);
    } else {
      otherParts.push(parts[i]);
    }
  }

  fqZZZParts.sort();

  otherParts.sort();

  let paramsArray = fqZZZParts;

  if (keyword != '*') {
    paramsArray.push('keyword=' + keyword);
  }

  paramsArray = paramsArray.concat(otherParts);

  return paramsArray.join('&');
}

export function injectPhpDebug(url: string): string {
  let version = getVersion();

  if (version == 'develop') {
    let disableInjection = false;

    let winAny: any = null;

    try {
      winAny = window;
    } catch {}

    disableInjection =
      winAny != null &&
      winAny.DISABLE_PHP_DEBUG == undefined &&
      winAny.DISABLE_PHP_DEBUG == true;

    if (!disableInjection) {
      if (url.includes('?')) url = url + '&XDEBUG_SESSION_START=session_name';
      else url = url + '?XDEBUG_SESSION_START=session_name';
    }
  }

  return url;
}

export function getVersion(): string {
  let version = 'develop';

  if (process.env.CI_PIPELINE_ID != null)
    version = '#' + process.env.CI_PIPELINE_ID;

  return version;
}
